import React from 'react';
import { Table, Typography } from 'antd';
import { formatDate, formatNumber } from '../../utils/reportFormatters';

const { Text } = Typography;

const ReportTable = React.memo(({ data, columns, title, totalCount }) => {
  // Convert column definitions to Ant Design format
  const tableColumns = columns.map((col) => ({
    title: col.label,
    dataIndex: col.key,
    key: col.key,
    sorter: (a, b) => {
      const aVal = a[col.key];
      const bVal = b[col.key];

      // Handle different types
      if (typeof aVal === 'number' && typeof bVal === 'number') {
        return aVal - bVal;
      }

      return String(aVal).localeCompare(String(bVal));
    },
    render: (value) => {
      // Auto-format based on value type
      if (value === null || value === undefined || value === '') {
        return <Text type="secondary">-</Text>;
      }

      // Check if it's a date string
      if (typeof value === 'string' && /\d{4}-\d{2}-\d{2}/.test(value)) {
        return formatDate(value);
      }

      // Check if it's a number
      if (typeof value === 'number') {
        return formatNumber(value);
      }

      return value;
    },
  }));

  return (
    <Table
      columns={tableColumns}
      dataSource={data}
      rowKey={(record, index) => `row-${index}`}
      pagination={{
        defaultPageSize: 10,
        showSizeChanger: true,
        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} records`,
        pageSizeOptions: ['10', '25', '50', '100'],
      }}
      scroll={{ x: 'max-content' }}
      size="middle"
      bordered
    />
  );
});

export default ReportTable;
